import { TooltipContent } from './TooltipContent';

export default TooltipContent;
